import { Box, Paper, styled } from "@mui/material";

export const LoginContainer = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  padding: 16px;
  box-sizing: border-box;
`;

export const LoginFormWrapper = styled(Paper)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 400px;
  max-width: 100%;
  box-sizing: border-box;
  padding: 20px;
  background-color: ${({ theme }) => theme.palette.background.paper};
  border-radius: 8px;
  gap: 16px;
`;

export const TitleWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
